<div
	[ngClass]="{
		'cv-historical-values': true,
		'cv-historical-values__arrow-top': arrowTop,
		'cv-historical-values__arrow-botoom': !arrowTop,
		'cv-historical-values__active': isOpen,
		'cv-historical-values__inactive': !isOpen
	}"
	#historicalEle
>
	<a href="javascript:void(0)" (click)="close()" class="cv-historical-values__close">X</a>
	<div class="cv-historical-values__title">Field revision history</div>
	<div class="cv-historical-values__container">
		<div class="cv-historical-values__content" *ngFor="let item of historical; let i = index">
			<label class="cv-historical-values__sub-title">Previous revision {{ i + 1 }}</label>
			<label class="cv-historical-values__pasValue">{{ item.val || item.Val }}</label>
			<label class="cv-historical-values__sub-title">{{
				item.created || item.Created | date: 'shortDate'
			}}</label>
		</div>
	</div>
</div>
